import React from 'react';
import { takeLatest, put, call, select, delay } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import { AUTH_LOGIN, LOADER_CLOSE, LOADER_OPEN, MODAL_CLOSE } from '../actions';

import user from '../../api/user';
import {
  REGION_PROVINCE_LIST_GET,
  REGION_PROVINCE_SET,
  UPDATE_EMAIL,
  UPDATE_PASSWORD,
  USER_INFO_GET,
} from '../actions/user';
import { ToastError, ToastSuccess } from '../../../ui/components/Toast';
import { HOME_CONFIGURATION_GET } from '../actions/home';
import routes from '../../../routes';

function* userInfoGet() {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(user.getInfo);
    yield put({ type: USER_INFO_GET._SUCCESS, response });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > user > userInfoGet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* userInfoGetWatch() {
  yield takeLatest(USER_INFO_GET._REQUEST, userInfoGet);
}

function* updateEmail({ payload }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      user.updateEmail,
      payload
    );
    yield put({ type: UPDATE_EMAIL._SUCCESS, response });
    if (response?.updated) {
      toast.success(<ToastSuccess title="Email cambiata correttamente" />);
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > user > updateEmail', err);
    toast.error(<ToastError title="Qualcosa è andato storto" />);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* updateEmailWatch() {
  yield takeLatest(UPDATE_EMAIL._REQUEST, updateEmail);
}

function* updatePassword({ payload }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      user.updatePassword,
      payload
    );
    yield put({ type: UPDATE_PASSWORD._SUCCESS, response });
    if (response?.updated) {
      toast.success(<ToastSuccess title="Password cambiata correttamente" />);
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > user > updatePassword', err);
    toast.error(<ToastError title="Qualcosa è andato storto" />);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* updatePasswordWatch() {
  yield takeLatest(UPDATE_PASSWORD._REQUEST, updatePassword);
}

function* regionProvinceSet({ payload, navigate }) {
  try {
    yield put({ type: LOADER_OPEN });
    const token = yield select((state) => state.user.tempToken);
    yield put({ type: AUTH_LOGIN._SUCCESS, token });
    yield navigate(routes.home.path);
    // need to effectively change route
    yield delay(0);
    const { data: { data: response } = {} } = yield call(
      user.regionProvinceSet,
      payload
    );
    yield put({ type: REGION_PROVINCE_SET._SUCCESS, response });
    if (response?.updated) {
      toast.success(
        <ToastSuccess title="Regione e provincia inseriti correttamente" />
      );
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > user > regionProvinceSet', err);
    toast.error(<ToastError title="Qualcosa è andato storto" />);
  } finally {
    yield put({ type: LOADER_CLOSE });
    yield put({ type: MODAL_CLOSE });
  }
}

function* regionProvinceSetWatch() {
  yield takeLatest(REGION_PROVINCE_SET._REQUEST, regionProvinceSet);
}

function* getRegionProvinceList() {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      user.getRegionProvinceList
    );
    yield put({ type: REGION_PROVINCE_LIST_GET._SUCCESS, response });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > user > getRegionProvinceList', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* getRegionProvinceListWatch() {
  yield takeLatest(REGION_PROVINCE_LIST_GET._REQUEST, getRegionProvinceList);
}

export default [
  userInfoGetWatch(),
  updateEmailWatch(),
  updatePasswordWatch(),
  regionProvinceSetWatch(),
  getRegionProvinceListWatch(),
];
